import Icon from '@/components/ui/AppIcon';

interface ImpactMetricCardProps {
  metric: {
    icon: string;
    title: string;
    baseline: string;
    year5Target: string;
    year10Target: string;
    year20Target: string;
    description: string;
  };
}

export default function ImpactMetricCard({ metric }: ImpactMetricCardProps) {
  return (
    <div className="bg-card rounded-lg shadow-institutional p-4 sm:p-6 border border-border hover:shadow-lg transition-shadow duration-300">
      <div className="flex items-center space-x-3 mb-2 sm:mb-4">
        <div className="flex items-center justify-center w-10 h-10 bg-accent/10 rounded-lg">
          <Icon
            name={metric.icon as any}
            size={24}
            variant="outline"
            className="text-accent"
          />
        </div>
        <h3 className="font-headline text-xl font-semibold text-foreground">
          {metric.title}
        </h3>
      </div>

      <p className="font-body text-sm text-text-secondary leading-relaxed mb-2 sm:mb-4">
        {metric.description}
      </p>

      <div className="space-y-1 sm:space-y-2">
        <div className="flex items-center justify-between py-2 border-b border-border">
          <span className="font-body text-sm text-muted-foreground">Baseline</span>
          <span className="font-body text-sm font-medium text-foreground">
            {metric.baseline}
          </span>
        </div>
        <div className="flex items-center justify-between py-2 border-b border-border">
          <span className="font-body text-sm text-muted-foreground">Year 5</span>
          <span className="font-body text-sm font-medium text-success">
            {metric.year5Target}
          </span>
        </div>
        <div className="flex items-center justify-between py-2 border-b border-border">
          <span className="font-body text-sm text-muted-foreground">Year 10</span>
          <span className="font-body text-sm font-medium text-success">
            {metric.year10Target}
          </span>
        </div>
        <div className="flex items-center justify-between py-2">
          <span className="font-body text-sm text-muted-foreground">Year 20</span>
          <span className="font-headline text-base font-semibold text-success">
            {metric.year20Target}
          </span>
        </div>
      </div>
    </div>
  );
}